import helper from '@/libs/forms';

export default {
  schema: {
    fields: [
      {
        type: 'array',
        label: 'Associated Entities',
        hint: 'Please list any other entities that you control or are a member of that acquire residential real estate or are an existing or former borrower of Anchor\'s?',
        model: 'associatedEntities',
        showRemoveButton: true,
        styleClasses: 'col-md-12',
        itemContainerClasses: 'pb-2 phone-item-container',
        itemFieldClasses: '',
        newElementButtonLabelClasses: 'btn btn-outline-anchor btn-sm mt-2 float-right',
        removeElementButtonClasses: 'btn btn-danger remove-phone-btn',
        newElementButtonLabel: '+ Add Entity',
        required: false,
        validator: 'array',
        items: {
          type: 'object',
          default: {},
          schema: {
            fields: [
              helper.simpleInput('text', 'Entity Name', null, 'name', true, 6),
              helper.tax('TIN (Tax ID)', 'tin', null, false, 6),
            ],
          },
        },
      },
    ],
  },
};



// WEBPACK FOOTER //
// ./src/components/entities/schemas/associatedEntitiesSchema.js